


import React from 'react';
import backgroundImage from '../assets/DownloadBG.png';

function Partner() {
  return (
    <div
      className="relative flex items-center justify-center w-full h-96 bg-cover bg-center" // Adjusted height here
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
      }}
    >
      {/* Overlay for dimming background */}
      <div className="absolute inset-0 bg-black opacity-60"></div>

      {/* Centered Content Box */}
      <div className="relative z-10 flex items-center justify-center w-full px-4">
        <div className="bg-black bg-opacity-90 p-6 rounded-lg text-white  md:text-center w-full sm:w-3/4 md:w-2/3 lg:w-3/4 xl:w-2/3">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-semibold mb-4">
            Become a MoveonWheels Partner
          </h2>
          <p className="text-sm sm:text-base mb-2">
            Start your own business with India's Largest Travel Platform.
          </p>
          <p className="text-sm sm:text-base">
            Rent Self-Drive Bikes, Cars, Bicycles, or Furniture. List Motorcycle Tours, Holidays, and Activities.
            <span className="block mt-2">Get bookings for your Hotel, Camp, or Homestays.</span>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Partner;
